import { render, staticRenderFns } from "./MdtGallery.vue?vue&type=template&id=20fe3af2&scoped=true"
import script from "./MdtGallery.vue?vue&type=script&lang=js"
export * from "./MdtGallery.vue?vue&type=script&lang=js"
import style0 from "./MdtGallery.vue?vue&type=style&index=0&id=20fe3af2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20fe3af2",
  null
  
)

export default component.exports